import CartProducts from '../CartProducts';
import FreeProductInCart from '../FreeProductInCart';

export default function index(props) {
  const {
    cartProducts,
    setSnackBarMessage,
    offerId,
    changeProductHandler,
    showCartFiller,
    offerListFetcher,
    paymentPage,
    isB2G1SkuAdded,
  } = props;
  return (
    <>
      {cartProducts?.offered_product?.map((item, index) => {
        return (
          <>
            {item.hasOwnProperty('saleOfferedProduct') && !showCartFiller ? (
              <FreeProductInCart
                product={item}
                changeProductHandler={changeProductHandler}
              />
            ) : (
              !item.hasOwnProperty('saleOfferedProduct') && (
                <CartProducts
                  key={'offeredItem' + item?.name + index}
                  product={item}
                  setSnackBarMessage={setSnackBarMessage}
                  offerProduct={true}
                  offerId={offerId}
                  offerListFetcher={offerListFetcher}
                  paymentPage={paymentPage}
                  isB2G1SkuAdded={isB2G1SkuAdded}
                />
              )
            )}
          </>
        );
      })}
    </>
  );
}
